import { Flex } from '@osmosis/react-ui/components/Box';
import { A } from '@osmosis/react-ui/components/Text';
import { P } from '@osmosis/react-ui/components/Text';
import React from 'react';
import { LoggedOutProductLibraryContainsItem } from '../../types/library';
import { formattedUrl } from '../../lib/library/format';
import { useLanguageContext } from '../../context/LanguageProvider';

type L3Props = {
  l3: LoggedOutProductLibraryContainsItem;
};

/**
 * LibraryL3PageLoggedOut.
 */
const LibraryL3PageLoggedOut = (props: L3Props) => {
  const { l3 } = props;
  const { activeLanguage } = useLanguageContext();

  return (
    <Flex
      data-testid="library-topic-box-l3-page"
      flexDirection="column"
      flexWrap="wrap"
      p={2}
      ml={3}
    >
      {l3?.contains?.map((l4: LoggedOutProductLibraryContainsItem) => {
        return (
          <A
            as="a"
            p={2}
            key={l4.name}
            data-id={l4.name}
            data-testid="library-topic-box-l4-link"
            href={formattedUrl(l4.name, {
              language: activeLanguage,
            })}
            sx={{
              textDecoration: 'none',
              borderRadius: 5,
              ':hover': {
                color: 'blue',
                backgroundColor: 'bg-2',
              },
              transition: 'color 0.4s',
            }}
          >
            <P
              color="gray70"
              fontWeight="body"
              fontSize={1}
              sx={{
                ':hover': {
                  color: 'blue',
                },
              }}
              data-testid="l3-page-name"
            >
              {l4.displayName || l4.name}
            </P>
          </A>
        );
      })}
    </Flex>
  );
};

export default LibraryL3PageLoggedOut;
